import gql from 'graphql-tag'

export const GET_BARCODE_PRODUCT_CATEGORY_LIST = gql`
  query GetBarcodeProductCategory {
    barcodeProductCategories {
      id
      name
    }
  }
`

export const GET_BARCODE_PRODUCT_CATEGORY_BY_ID = gql`
  query GetPresetCategoryById($id: Int!) {
    barcodeProductCategory(id: $id) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/BarcodeProductCategory.js